import React, { useState } from "react";

import Section from "pages/home/components/section";
import Product from "pages/home/components/product";
import PickedProduct from "pages/home/components/picked-product";
import InvoiceTable from "pages/home/components/invoice-table";
import { TokenData, useAuthContext } from "store/auth";
import { Navigate } from "react-router-dom";
import { useProducts } from "hooks/use-products";
import { Carousel, Spinner } from "react-bootstrap";
import ErrorMessage from "components/error/error";
import { useAppTags } from "hooks/useApps";
import { json } from "helpers/data";
import { useInvoices } from "hooks/use-invoices";
import ProductsWaits from "./components/productsWaits";

import { CustomerTicketsParams, useTickets } from "pages/tickets/ticket.service";
import TicketCard from "./components/ticket-card";
import HomeNoData from "./components/HomeNoData";
import { useTranslation } from "react-i18next";
import {useQuery} from "react-query";
import {client} from "../../helpers/client";

const InitialCustomerTicketsParams: CustomerTicketsParams = {
  StatusId: 0,
  Search: "",
  FromDate: "",
  ToDate: "",
  PageNumber: 1,
  PageSize: 4
};

const HomePage = () => {
  const [{ isLoggedIn, user }] = useAuthContext();
  return (
    <>
     {!isLoggedIn ? ( <Navigate to="/download-center" />) : HomePageWithLogin(user)}
    </>
   
  );
};

const HomePageWithLogin =(user:Partial<TokenData>)=>{
  const { products, isLoading, isSuccess, isError } = useProducts();
 const { data:invoices } = useQuery<any>(['invoices-data'], async () => {
    const { response } = await client("/invoice/getPagedList", { params: {InvoiceStatusId: 0, SortingDirection: "DESC" } })
    if (response) return response
  })
  const { tickets, totalCount, isLoading: loadingTickets } = useTickets(InitialCustomerTicketsParams);
  const { appTags } = useAppTags();
  const { t } = useTranslation("home");

  return (
    <div className="customerHome">
      <div className="divTop">
        <h1 className="headTitle">
          <span>{t("hello") as string}.</span> {user.Name}
        </h1>
        <div className="row">
          <div className="col-xl-4 col-lg-6">
            <Section title={t("navbar.myProducts")} count={products?.length} link="/my-products">
              {isError && <ErrorMessage />}
              {isLoading && (
                <div className="my-center">
                  <Spinner animation="grow" variant="primary" />
                </div>
              )}
              <div className="all-tackets p-0">
              {isSuccess &&
                products
                  ?.slice(0, 3)
                  .map((pro: any) => (
                    <Product
                      key={pro.versionSubscriptionId}
                      logo={pro?.logo?.fullPath}
                      name={pro?.versionName}
                      versionSubscriptionId={pro?.versionSubscriptionId}
                      priceLevel={`${json(pro?.priceLevel)} -  ${pro?.usedDevice}/${pro?.numberOfLicenses}  - ${
                        pro?.price?.discrimination
                      }`}
                    />
                  ))}
              </div>
          
                {(products.length === 0 && !isLoading) &&  
                ( <div className="all-tackets">
                   <HomeNoData />
                  </div>)
                  }
            </Section>
          </div>

          <div className="col-xl-4 col-lg-6">
            <Section title={t("navbar.invoices")} count={invoices?.totalCount} link="/invoices">
              {isError && <ErrorMessage />}
              {isLoading && (
                <div className="my-center">
                  <Spinner animation="grow" variant="primary" />
                </div>
              )}
               <div className="all-tackets">
               {(isSuccess && invoices?.totalCount  > 0 && !isLoading ) && (<InvoiceTable invoices={invoices?.items?.slice(0, 5) || 0} />) }
               {(isSuccess && invoices?.totalCount === 0 && !isLoading ) &&  (<HomeNoData />) }
               </div>
            
            </Section>
          </div>

          <div className="col-xl-4 col-lg-12">
            <Section title={t("navbar.tickets")} count={totalCount} link="/tickets">
              {/* <p>there is nothing here yet.</p> */}
              {loadingTickets && (
                <div className="my-center">
                  <Spinner animation="grow" variant="primary" />
                </div>
              )}
              <div className="all-tackets">
                <Carousel indicators controls={false}>
                  {tickets?.map((page) =>
                    page?.tickets.map((ticket, index) => (
                      <Carousel.Item>
                        <TicketCard key={index} ticket={ticket} />
                      </Carousel.Item>
                    ))
                  )}
                </Carousel>
                {(totalCount === 0 && !loadingTickets) && (<HomeNoData />)}
              </div>
            </Section>
          </div>
        </div>
      </div>

      <div className="divBottom">
        <h1 className="headTitle">
        {t("speciallyPicked") as string} <span> {t("forYou") as string}</span>
        </h1>
        <div className="row">
          {isError && <ErrorMessage />}
          {isLoading && (
            <div className="my-center">
              <Spinner animation="grow" variant="primary" />
            </div>
          )}
          {isSuccess &&
            appTags?.slice(0, 3).map((tag: any) => (
              <div className="col-xl-3 col-lg-4 col-md-6" key={tag?.id}>
                <PickedProduct logo={tag?.logo?.fullPath} name={tag?.name} info={tag?.title} price={tag?.price} id={tag?.id} />
              </div>
            ))}
          {appTags?.length > 3 && (
            <div className="col-xl-3 col-lg-4 col-md-6">
              <ProductsWaits apptags={appTags} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default HomePage;
